<template>
  <BContainer>
    <section class="hero">
      <div class="hero-body is-paddingless is-marginless">
        <div class="column is-3">
          <div class="field is-grouped">
            <div class="control">
              <div class="field has-addons">
                <div class="">
                  <b-datepicker
                    :placeholder="$t('description.selectDateRange')"
                    v-model="dates"
                    range
                    :max-date="new Date()"
                    :mobile-native="false"
                    :first-day-of-week="dateSettings.firstDayOfWeek"
                    :month-names="dateSettings.monthNames"
                    :day-names="dateSettings.dayNames"
                  ></b-datepicker>
                </div>
                <div class="control">
                  <b-button icon-left="fa fa-calendar-times" @click="clearDates"></b-button>
                </div>
              </div>
            </div>
            <div class="control">
              <button class="button is-primary" @click="getReport">
                {{ $t('button.prepareReport') }}
              </button>
            </div>
            <div class="control">
              <DownloadExcel
                :data="exportData"
                :fields="excelFields"
                v-if="downloadActive"
                :before-finish="downloadFinished"
                :name="excelName"
              >
                <button class="button is-primary">{{ $t('button.download') }}</button>
              </DownloadExcel>
              <button class="button is-primary" v-if="!downloadActive" disabled>
                {{ $t('button.download') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </BContainer>
</template>

<script>
import format from 'date-fns/format'
import dateSettings from '@/_helpers/date.config'
import ApiService from '../../../_api/api.service'

export default {
  data() {
    return {
      dates: [],
      exportData: [],
      dateSettings,
      downloadActive: false,
      excelFields: {},
      excelName: ''
    }
  },
  mounted() {
    this.excelFields = this.getExcelFields()
  },
  methods: {
    clearDates() {
      this.dates = []
    },
    getReport() {
      let startDate = ''
      let endDate = ''
      if (this.dates.length > 0) {
        startDate = format(this.dates[0], 'yyyy-MM-dd')
        endDate = format(this.dates[1], 'yyyy-MM-dd')
      }
      this.excelName = `${startDate}_${endDate}_data.xls`
      ApiService.get(`/admin/export?startDate=${startDate}&endDate=${endDate}`).then(data => {
        this.downloadActive = true
        if (data && data.length > 0) {
          this.exportData = data.map(d => {
            const dataItem = {
              name: `${d.user.firstname} ${d.user.lastname}`,
              sectorGroup: d.user.sector.parentSector.name,
              sector: d.user.sector.name,
              city: d.user.city.name,
              process: d.answerSet.process.name,
              date: format(new Date(d.answerSet.submitDate), dateSettings.datetimeFormat),
              ...d
            }
            delete dataItem.user
            delete dataItem.answerSet
            return dataItem
          })
        }
      })
    },
    downloadFinished() {
      this.downloadActive = false
    },
    getExcelFields() {
      const fields = {}
      fields[this.$t('validation.attributes.fullName')] = 'name'
      fields[this.$t('validation.attributes.sectorGroup')] = 'sectorGroup'
      fields[this.$t('validation.attributes.sector')] = 'sector'
      fields[this.$t('validation.attributes.city')] = 'city'
      fields[this.$t('validation.attributes.process')] = 'process'
      fields[this.$t('validation.attributes.date')] = 'date'
      fields[this.$t('title.netaScore')] = 'finalScore'
      fields[this.$t('title.abuse')] = 'abuseFinal'
      fields[this.$t('title.adaptation')] = 'adaptationFinal'
      fields[this.$t('title.controlActivities')] = 'controlActivitiesScore'
      fields[this.$t('title.controlEnvironment')] = 'controlEnvironmentScore'
      fields[this.$t('title.financialReport')] = 'financialReportFinal'
      fields[this.$t('title.informationCommunication')] = 'informationCommunicationScore'
      fields[this.$t('title.monitoring')] = 'monitoringScore'
      fields[this.$t('title.operation')] = 'operationFinal'
      fields[this.$t('title.riskAssessment')] = 'riskAssessmentScore'
      return fields
    }
  }
}
</script>
<style>
.export-table {
  overflow: auto !important;
}
</style>
